import { HOLIDAY_STATUS } from "../../assets/data/holidayStatus";
import { MonthDataParams } from "../../interface/monthDataInterface";

export function getHolidaysInCurrentMonth(holidays: MonthDataParams[]): number {
    const currentDate = new Date();
    const currentMonth = currentDate.getMonth() + 1; // Months are zero-indexed
    const currenYear = currentDate.getFullYear();

    let weekdays = 0;

    holidays.forEach((holiday) => {
        const fromDate = new Date(holiday.from_date);
        const toDate = new Date(holiday.to_date);
        const holidayYear = new Date(holiday.from_date).getFullYear();
        const holidayMonth = fromDate.getMonth() + 1;

        if (
            holidayMonth === currentMonth &&
            currenYear === holidayYear &&
            holiday.status === HOLIDAY_STATUS.Approved
        ) {
            for (let day = fromDate; day <= toDate; day.setDate(day.getDate() + 1)) {
                let dayOfWeek = day.getDay(); // Sunday = 0, Monday = 1, ..., Saturday = 6
                let month = day.getMonth() + 1;
                if ((dayOfWeek !== 0 && dayOfWeek !== 6) && month == currentMonth) { // Exclude Sunday (0) and Saturday (6)
                    weekdays++;
                }
            }
        }
    });

    return weekdays;
}
